import _ from 'underscore';
import _s from 'underscore.string';

let ACTION_CREATORS = {};

export default function (resources, actions, prefixedId = false) {
  _.forEach(resources, resourceName => {
    const ResourceName = _s.capitalize(resourceName);
    const RESOURCE_NAME = resourceName.toUpperCase();

    // get
    ACTION_CREATORS[ `get${ResourceName}s` ] = (dao, params, resetState = true) => {
      const promise = dao[ `${resourceName}s` ].get(params);

      const onSuccess = (dispatch, resources) => {
        if (resetState) {
          dispatch({
            type: actions[ `GET_${RESOURCE_NAME}S_SUCCESS` ],
            [ `${resourceName}s` ]: resources,
          });
        } else {
          dispatch({
            type: actions[ `GET_${RESOURCE_NAME}S_SUCCESS_ADD` ],
            [ `${resourceName}s` ]: resources,
          });
        }
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `GET_${RESOURCE_NAME}S_ERROR` ], error });
      };

      return (dispatch) => {
        dispatch({ type: actions[ `GET_${RESOURCE_NAME}S` ], promise });

        return promise
          .then(response => onSuccess(dispatch, response[ `${resourceName}s` ]))
          .catch(() => true);
      };
    };

    // getAll
    ACTION_CREATORS[ `getAll${ResourceName}s` ] = (dao, params, resetState = true) => {
      const promise = dao[ `${resourceName}s` ].getAll(params);

      const onSuccess = (dispatch, resources) => {
        if (resetState) {
          dispatch({
            type: actions[ `GET_ALL_${RESOURCE_NAME}S_SUCCESS` ],
            [ `${resourceName}s` ]: resources,
          });
        } else {
          dispatch({
            type: actions[ `GET_ALL_${RESOURCE_NAME}S_SUCCESS_ADD` ],
            [ `${resourceName}s` ]: resources,
          });
        }
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `GET_ALL_${RESOURCE_NAME}S_ERROR` ], error });
      };

      return (dispatch) => {
        dispatch({ type: actions[ `GET_ALL_${RESOURCE_NAME}S` ], promise, });

        return promise
          .then(response => onSuccess(dispatch, response[ `${resourceName}s` ]))
          .catch(error => onError(dispatch, error));
      };
    };

    // getSingle
    ACTION_CREATORS[ `getSingle${ResourceName}` ] = (dao, id) => {
      const promise = dao[ `${resourceName}s` ].getSingle(id);

      const onSuccess = (dispatch, resource) => {
        dispatch({ type: actions[ `GET_SINGLE_${RESOURCE_NAME}_SUCCESS` ], [ `${resourceName}` ]: resource });
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `GET_SINGLE_${RESOURCE_NAME}_ERROR` ], error });
      };

      return (dispatch) => {
        dispatch({ type: actions[ `GET_SINGLE_${RESOURCE_NAME}` ], promise, });

        return promise
          .then(resource => {
            onSuccess(dispatch, resource);
            return resource;
          })
          .catch(error => onError(dispatch, error));
      };
    };

    // save
    ACTION_CREATORS[ `save${ResourceName}` ] = (dao, resource, skipLocal = false) => {
      const promise = dao[ `${resourceName}s` ].save(resource);

      const onSuccess = (dispatch, response) => {
        const idProp = prefixedId ? `${resourceName}_id` : 'id';
        let resourceResponse = resource;
        if (!resource[ idProp ] && response[ idProp ]) {
          resourceResponse = { ...resource, [ idProp ]: response[ idProp ] };
        }
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}_SUCCESS` ], [ resourceName ]: resourceResponse });
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}_ERROR` ], [ resourceName ]: resource, error });
        throw error;
      };

      return (dispatch) => {
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}` ], promise, [ resourceName ]: resource, skipLocal });

        return promise
          .then((response) => {
            onSuccess(dispatch, response);
            return response;
          })
          .catch((error) => onError(dispatch, error));
      };
    };

    // save multiple
    ACTION_CREATORS[ `save${ResourceName}s` ] = (dao, resources) => {
      const promise = dao[ `${resourceName}s` ].saveAll(resources);

      const onSuccess = (dispatch, resources) => {
        // Relying on optimistic update.
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}S_SUCCESS` ], [ `${resourceName}s` ]: resources });
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}S_ERROR` ], [ `${resourceName}s` ]: resources, error });
        throw error;
      };

      return (dispatch) => {
        dispatch({ type: actions[ `SAVE_${RESOURCE_NAME}S` ], promise, [ `${resourceName}s` ]: resources });

        return promise
          .then((resources) => onSuccess(dispatch, resources))
          .catch((error) => onError(dispatch, error));
      };
    };

    // delete
    ACTION_CREATORS[ `delete${ResourceName}` ] = (dao, resource) => {
      const promise = dao[ `${resourceName}s` ].destroy(resource);

      const onSuccess = (dispatch) => {
        dispatch({
          type: actions[ `DELETE_${RESOURCE_NAME}_SUCCESS` ],
          [ resourceName ]: resource,
          onClickUndo: () => dispatch(ACTION_CREATORS[ `save${ResourceName}` ](dao, resource))
        });
      };

      const onError = (dispatch, error) => {
        dispatch({ type: actions[ `DELETE_${RESOURCE_NAME}_ERROR` ], [ resourceName ]: resource, error, });
      };

      return (dispatch) => {
        dispatch({ type: actions[ `DELETE_${RESOURCE_NAME}` ], promise, [ resourceName ]: resource });

        return promise
          .then(() => onSuccess(dispatch))
          .catch((error) => onError(dispatch, error));
      };
    };
  });

  return ACTION_CREATORS;
};
